import { useState, type ReactNode } from 'react';
import { gateRequired, checkPin, gateStorageKey } from '../lib/tabletGate';

/**
 * Gate du mode tablette (parité C10). Si le tenant a un `tablet_pin`, on demande
 * ce PIN une fois (mémorisé en localStorage) ; sinon accès libre (rétro-compatible).
 */
interface TabletGateProps {
  tenantId: string;
  pin?: string | null;
  children: ReactNode;
}

export default function TabletGate({ tenantId, pin, children }: TabletGateProps) {
  const required = gateRequired(pin);
  const [ok, setOk] = useState<boolean>(() => {
    if (!required) return true;
    return typeof localStorage !== 'undefined' && localStorage.getItem(gateStorageKey(tenantId)) === '1';
  });
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);

  if (ok) return <>{children}</>;

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (checkPin(input, pin)) {
      if (typeof localStorage !== 'undefined') localStorage.setItem(gateStorageKey(tenantId), '1');
      setOk(true);
    } else {
      setError(true);
    }
  };

  return (
    <form onSubmit={submit} className="mx-auto mt-10 flex w-full max-w-xs flex-col gap-3 text-center">
      <h2 className="text-lg font-bold text-brand-primary">Accès tablette</h2>
      <p className="text-sm opacity-70">Entrez le code d'accès du restaurant.</p>
      <input
        type="password"
        inputMode="numeric"
        autoFocus
        value={input}
        onChange={(e) => {
          setInput(e.target.value);
          setError(false);
        }}
        className="rounded-lg border border-slate-300 p-3 text-center text-lg focus:outline-none focus:ring-2"
        style={{ ['--tw-ring-color' as string]: 'var(--brand-primary)' }}
        placeholder="Code"
      />
      {error && <p className="text-sm text-red-600">Code incorrect.</p>}
      <button
        type="submit"
        className="rounded-xl py-3 font-semibold text-white"
        style={{ background: 'var(--brand-primary)' }}
      >
        Déverrouiller
      </button>
    </form>
  );
}
